import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: 'What is Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet is a comprehensive resource hub that aggregates thousands of verified products, trusted sellers, and detailed buying guides from the KaSpreadsheet platform. It helps shoppers discover quality fashion items, accessories, and lifestyle products quickly and safely. Updated weekly, our spreadsheet covers 14 product categories with over 20,000 items.',
  },
  {
    question: 'How often is the Kakobuy Spreadsheet updated?',
    answer: 'The Kakobuy Spreadsheet is updated weekly with new product listings, seller verifications, and fresh buying guides. Our team continuously monitors product availability, seller ratings, and market trends to ensure you always have access to the most current and reliable information.',
  },
  {
    question: 'Is the Kakobuy Spreadsheet safe to use?',
    answer: 'Yes, Kakobuy Spreadsheet prioritizes safety. We only list products from verified sellers with proven track records. Each listing includes QC inspection tips, detailed product descriptions, and direct links to the original KaSpreadsheet pages. We also provide comprehensive safety guides covering secure payment methods, shipping best practices, and how to avoid counterfeit items.',
  },
  {
    question: 'How do I use the Kakobuy Spreadsheet to find products?',
    answer: 'Using Kakobuy Spreadsheet is straightforward. Browse our 14 categories using the dropdown menu or category grid on this page. Each category links directly to verified product collections on KaSpreadsheet. You can also check our buying guides and tutorials for step-by-step instructions on navigating the spreadsheet, verifying sellers, and placing orders.',
  },
  {
    question: 'Which product categories are available?',
    answer: 'Kakobuy Spreadsheet covers 14 categories: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear/Underpants, Jersey, Accessories, Bags, Belts, Perfumes, and OtherStuff. Each category contains carefully curated product listings with direct links to the KaSpreadsheet platform.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <h2 className="text-foreground-950 text-3xl md:text-4xl font-bold font-heading text-center mb-14">
          Frequently Asked Questions
        </h2>

        <div className="space-y-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <span className="text-foreground-950 font-semibold text-base md:text-lg pr-4">
                  {faq.question}
                </span>
                <span className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${openIndex === idx ? 'bg-accent-500 rotate-45' : 'bg-background-200'}`}>
                  <i className="ri-add-line text-foreground-700"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === idx ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="px-5 md:px-6 pb-5 md:pb-6 text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}